/*
  ACORN v16 (29/10/2026) - header slims once the page is scrolled about 100px (desktop, 1000px and up).
  The header itself is made sticky and hide-on-scroll by the theme's own settings (sections/header-group.json), so it hides
  as you scroll down and comes back as soon as you scroll up. This script only adds the "slim" state.
  The slim state adds the class acorn-slim to <html> (see assets/acorn-v16.css). To stop the content jumping up when the
  header gets shorter, the header's own bottom margin is set to the height it lost, so the page below does not move.
*/
(function () {
  'use strict';

  var root = document.documentElement;
  var wide = window.matchMedia('(min-width: 1000px)');
  var slim = false;

  function wrapper() { return document.querySelector('.shopify-section--header'); }

  function setSlim(on) {
    var sec = wrapper();
    if (!sec || on === slim) return;
    var before = sec.getBoundingClientRect().height;
    root.classList.toggle('acorn-slim', on);
    var after = sec.getBoundingClientRect().height;
    sec.style.marginBottom = on && before > after ? (before - after) + 'px' : '';
    slim = on;
  }

  function update() {
    var y = window.pageYOffset || root.scrollTop || 0;
    if (!wide.matches) { setSlim(false); return; }
    if (!slim && y > 100) setSlim(true);
    else if (slim && y < 40) setSlim(false);
  }

  // Scroll events already arrive at most once per frame, and update() only does layout work when the state flips,
  // so it is called straight from the event.
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', function () { setSlim(false); update(); }, { passive: true });
  if (wide.addEventListener) wide.addEventListener('change', function () { setSlim(false); update(); });
  update();
})();
